__turbopack_context__.v({
  "content": "AssignmentWidgetSlim-module-scss-module__wUK1La__content",
  "description": "AssignmentWidgetSlim-module-scss-module__wUK1La__description",
  "fade-in": "AssignmentWidgetSlim-module-scss-module__wUK1La__fade-in",
  "gradient": "AssignmentWidgetSlim-module-scss-module__wUK1La__gradient",
  "no-transform": "AssignmentWidgetSlim-module-scss-module__wUK1La__no-transform",
  "rotate": "AssignmentWidgetSlim-module-scss-module__wUK1La__rotate",
  "widget": "AssignmentWidgetSlim-module-scss-module__wUK1La__widget",
  "wrapper": "AssignmentWidgetSlim-module-scss-module__wUK1La__wrapper",
});
